import React from 'react';
import VoucherPage from './VoucherPage';

const WebhostingLowCostPage: React.FC = () => {
  return <VoucherPage category="webhostingLowCost" />;
};

export default WebhostingLowCostPage;
